import { render, staticRenderFns } from "./VehicleAvailabilityDashboard.vue?vue&type=template&id=280ea64e&scoped=true"
import script from "./VehicleAvailabilityDashboard.vue?vue&type=script&lang=js"
export * from "./VehicleAvailabilityDashboard.vue?vue&type=script&lang=js"
import style0 from "./VehicleAvailabilityDashboard.vue?vue&type=style&index=0&id=280ea64e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ea64e",
  null
  
)

export default component.exports